export default "__VITE_ASSET__bghuX9jL__"